import { NotePage } from '../NotePage/NotePage';
import { StemCellsParagraphs } from './Paragraphs';

export const StemCells = () => (
  <NotePage
    title="Cellular repair and stem cell concepts"
    eyebrow="Wellness note"
    summary="A concise article about cellular health, recovery concepts, and how to frame questions around emerging regenerative medicine language."
    paragraphs={StemCellsParagraphs}
    relatedTitle="Stem Cells"
    appointmentServiceValue="Stem Cells"
  />
);
